import { AccessType } from './access-type';

/** Translation key and English fallback of each access type, for tables and selects (#6263). */
export interface AccessTypeLabel {
  value: AccessType;
  key: string;
  fallback: string;
}

export const ACCESS_TYPE_LABELS: AccessTypeLabel[] = [
  { value: AccessType.Standard, key: 'AccessType_Standard', fallback: 'Standard' },
  { value: AccessType.Global, key: 'AccessType_Global', fallback: 'Global' },
];

/** The label of a group's or role's type; a missing type is Standard, as in the API. */
export function accessTypeLabel(type: AccessType | undefined): AccessTypeLabel {
  return ACCESS_TYPE_LABELS.find((label) => label.value === (type ?? AccessType.Standard)) ?? ACCESS_TYPE_LABELS[0];
}
